import { ApplicationEvent } from './application-event.model';
import { ApplicationEventType } from '../constants';

export class MiniCartApplicationEvent implements ApplicationEvent {
  type = ApplicationEventType.MiniCartInteraction;

  constructor(private eventType: string, private label: string) {}

  getPayload(): any {
    return {
      category: ApplicationEventType.Interaction,
      type: this.eventType,
      label: this.label
    };
  }
}
